import React, { useEffect, useState, useContext } from "react";

import axios from "axios";
import Helmet from "react-helmet";
import { BASE_URL, GET_HOME_PAGE_DATA, FETCH_GUIDE } from "../api/constants";
import qs from "qs";

import { WebsiteContext } from "../context/websiteContext";
import HeroVideo2 from "../components/HeroVideo/HeroVideo2";

import TrendingInDubai from "../components/TrendingInDubai/TrendingInDubai";
import FeaturedProjects from "../components/FeaturedProjects/FeaturedProjects";
import CommunitySectionV2 from "../components/Community/CommunitySectionV2";
import AgentCardV3 from "../components/AgentCard/AgentCardV3";
import ProjectOfTheMonthV1 from "../components/ProjectOfTheMonth/ProjectOfTheMonthV1";
import GuidesCardV3 from "../components/GuidesCard/GuidesCardV3";
import NewsAndInsightsCardV4 from "../components/NewsAndInsightsCard/NewsAndInsightsCardV4";
import FindYourDreamHomeV1 from "../components/FIndYourDreamHome/FindYourDreamHomeV1";
import FAQsV1 from "../components/FAQs/FAQsV1";
import CustomButton from "../components/CutomButton/CustomButton";
import FeaturedProjectsOldData from "../components/FeaturedProjects/FeaturedProjectsOldData";
import { shuffle } from "../helper/shuffleArray";
import { Link } from "react-router-dom";

function HomeNew() {
  const [data, setData] = useState({});
  const [newData, setNewData] = useState({});
  const [guides, setGuides] = useState([]);

  const [reviews, setReviews] = useState([]);

  const { setShowAreas } = useContext(WebsiteContext);
  useEffect(() => {
    setShowAreas(false);
  }, [setShowAreas]);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(BASE_URL);
        const homePageData = response.data;
        setData(homePageData);

        setReviews(homePageData?.reviews || []);
      } catch (error) {
        console.error("Error fetching home data:", error);
      }
    };
    const queryStr = qs.stringify(
      {
        populate: [
          "homepage_video",
          "community_section_cards",
          "community_section_cards.area_image",
          "Faqs",
          "project_of_the_month_key_features",
          "google_review_cards",
          "featured_projects",
          "featured_projects.featured_project_image",
          "featured_agents",
          "featured_agents.agent_image",
          "project_of_the_month_video_thumbnail",
          "featured_dvelopers",
          "featured_dvelopers.developer_logo_image",
          "featured_villas",
          "featured_villas.featured_project_image",
          "featured_townhouses",
          "featured_townhouses.featured_project_image",
          "featured_apartments",
          "featured_apartments.featured_project_image",
          "insightful_blogs",
          "insightful_blogs.cover",
          "insightful_blogs.category",
        ],
      },
      {
        encodeValuesOnly: true,
      }
    );

    const fetchHomeDatafromStrapi = async () => {
      try {
        const response = await axios.get(`${GET_HOME_PAGE_DATA}?${queryStr}`);
        setNewData(response?.data?.data);
      } catch (error) {
        console.error("Error fetching home data:", error);
      }
    };

    const queryStr2 = qs.stringify(
      {
        filters: {
          show_guide: true,
        },
        fields: ["guide_name", "hero_heading", "guide_slug"],
        populate: ["guide_featured_image"],
      },
      {
        encodeValuesOnly: true,
      }
    );

    const fetchGuidesData = async () => {
      try {
        const response = await axios.get(`${FETCH_GUIDE}?${queryStr2}`);
        setGuides(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching guides data:", error);
      }
    };

    fetchHomeData();
    fetchHomeDatafromStrapi();
    fetchGuidesData();
  }, []);

  return (
    <div className="overflow-x-hidden">
      <Helmet>
        <link rel="alternate" hreflang="en-ae" href="https://www.xrealty.ae/" />
        <link rel="alternate" hreflang="en-us" href="https://www.xrealty.ae/" />
        <link rel="alternate" hreflang="en-gb" href="https://www.xrealty.ae/" />
        <link rel="alternate" hreflang="en-sg" href="https://www.xrealty.ae/" />
        <link
          rel="alternate"
          hreflang="en-in"
          href=" https://www.xrealty.ae/"
        />
        <link rel="alternate" hreflang="en" href=" https://www.xrealty.ae/" />
        <link
          rel="alternate"
          hreflang="x-default"
          href=" https://www.xrealty.ae/ "
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Xperience Realty",
            url: "https://www.xrealty.ae/",
            logo: "https://res.cloudinary.com/dkhns25jh/image/upload/v1733821293/xr_media/sqmxma6remiuh1mbv4x7.png",
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+97147049400",
                contactType: "sales",
              },
              {
                "@type": "ContactPoint",
                telephone: "+971564080888",
                contactType: "sales",
              },
            ],
            sameAs: [
              "https://www.facebook.com/profile.php?id=61562378023612",
              "https://x.com/xrealty_ae",
              "https://www.instagram.com/xperience.realty",
              "https://www.youtube.com/@xrealtyae",
              "https://www.linkedin.com/company/xrealty-ae",
            ],
          })}
        </script>

        {/* <script type="text/javascript">
          {`
window.criteo_q = window.criteo_q || [];
var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
window.criteo_q.push(
 { event: "setAccount", account: "119119" }, 
  { event: "setEmail", email: "" },
 { event: "setSiteType", type: deviceType },
 { event: "viewHome" }
);
          `}
        </script> */}
      </Helmet>
      <style>
        {`
          .agent-slider {
            width: 100% !important;
          }
          .agent-slider .slick-track {
            display: flex;
            justify-content: center;
          }
          .agent-slider .slick-slide {
            float: none;
          }
          @media (min-width: 1024px) {
            .agent-slider .slick-slide > div {
              margin: 0 4px;
            }
          }
          @media (max-width: 1023px) {
            .agent-slider .slick-slide > div {
              margin: 0 4px;
            }
          }
        `}
      </style>

      {/* Hero Section - White Background (default) */}
      <div className="relative">
        <HeroVideo2 videoData={newData?.homepage_video} />
      </div>

      {/* Trending in Dubai Section */}
      <div>
        <TrendingInDubai
          villas={newData?.featured_villas}
          townhouses={newData?.featured_townhouses}
          apartments={newData?.featured_apartments}
        />
      </div>

      {/* Featured Projects*/}
      <div className="mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
        <FeaturedProjects
          title={"Featured Projects"}
          data={newData?.featured_projects}
        />
      </div>

      {/* Hot Communities */}
      <div className="bg-black ">
        <div className=" py-8 mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
          <CommunitySectionV2
            communityData={newData?.community_section_cards}
          />
        </div>
      </div>

      {/* Meet the Team */}
      <div className="mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
        <AgentCardV3 agentData={shuffle(newData?.featured_agents)} />
      </div>

      {/* Project of the month new */}
      <div className="bg-black">
        <div className="py-8 md:pt-8 md:pb-10 mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
          <ProjectOfTheMonthV1
            name={newData?.project_of_the_month_name}
            videoUrl={newData?.project_of_the_month_video_url}
            watchMoretext={newData?.project_of_the_month_video_watch_more_text}
            watchMoreUrl={newData?.project_of_the_month_video_watch_more_url}
            thumbnail={newData?.project_of_the_month_video_thumbnail}
          />
        </div>
      </div>

      {/* Exclusive Properties */}
      <div className="mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
        <FeaturedProjectsOldData
          title={"Xclusive Properties"}
          data={data?.properties?.slice(0, 20)}
        />
      </div>

      {/* Property Guides New Section */}
      <div className="bg-black ">
        <div className="py-8 md:pt-8 md:pb-10 mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
          <GuidesCardV3 data={guides} />
        </div>
      </div>

      {/* Featured Developers */}
      <div className="mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
        <div className="flex flex-col gap-4">
          <h2 className="font-[optima-lt-pro] xl:mb-4 font-[500] uppercase text-xl xs:text-xl md:text-3xl 2xl:text-4xl">
            Featured Developers
          </h2>
          <div className="flex flex-row flex-wrap gap-4 justify-evenly">
            {newData?.featured_dvelopers?.map((item, index) => {
              return (
                <Link
                  reloadDocument
                  draggable="false"
                  to={item?.developer_page_link}
                  key={index}
                  className="w-[120px] h-[70px] md:w-[100px]  md:h-[80px] shrink-0 bg-gray-100 p-2 cursor-pointer"
                >
                  <img
                    alt={item?.developer_logo_image?.alternativeText}
                    src={
                      item?.developer_logo_image?.formats?.medium?.url ||
                      item?.developer_logo_image?.url
                    }
                    className="w-[80%] h-full md:h-[55px] mx-auto object-contain"
                  />
                </Link>
              );
            })}
          </div>
        </div>
      </div>

      {/* News and Insights Card New Section */}
      <div className="bg-black ">
        <div className="py-8 md:pt-8 md:pb-10 mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
          <NewsAndInsightsCardV4 newData={newData?.insightful_blogs} />
        </div>
      </div>

      {/* Find Your Dream Home New */}
      <div className="bg-[url('https://res.cloudinary.com/dkhns25jh/image/upload/w_1280,f_auto,q_auto/v1745218644/xr_media/zosz2w8ve8l1swkgzfs4.png')] md:bg-[url('https://res.cloudinary.com/dkhns25jh/image/upload/w_1920,f_auto,q_auto/v1745218644/xr_media/zosz2w8ve8l1swkgzfs4.png')] bg-cover bg-no-repeat bg-center">
        <div className="px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl xl:mx-auto 2xl:px-0">
          <FindYourDreamHomeV1 />
        </div>
      </div>

      {/* FAQs Section - White Background */}
      <div className="mt-8 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl md:mt-12 xl:mt-16 xl:mx-auto 2xl:px-0">
        <div className="flex flex-col gap-2 justify-center mb-4">
          <h2 className="font-[optima-lt-pro] font-[500] uppercase text-xl xs:text-xl md:text-3xl 2xl:text-4xl">
            Frequently Asked Questions
          </h2>
          {/* <span className="text-gray-500 text-sm font-[lato] md:text-base">
            Find answers to common questions about investing in Dubai's luxury
            real estate market.
          </span> */}
        </div>
        <FAQsV1 faqs={newData?.Faqs} />
        <div className="w-full mt-4 mb-8 md:w-[35%] lg:w-[25%] xl:w-[20%]">
          <CustomButton
            name={"View All Faqs"}
            textBlack={true}
            link={"/faqs/"}
          />
        </div>
      </div>
    </div>
  );
}

export default HomeNew;
